import { i18n } from 'i18next';

import { JSON_META_SCHEMA, JSON_META_SCHEMAS } from './const';

export const getJsonMetaSchema = (i18n: i18n): unknown =>
  JSON_META_SCHEMAS[i18n.resolvedLanguage || i18n.language] || JSON_META_SCHEMA;

export const schemaGetPropertyNamesWithSpaces = (schema: unknown): string[] => {
  const names = new Set<string>();
  const visit = (node: unknown): void => {
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    if (!node || typeof node !== 'object') return;
    const obj = node as Record<string, unknown>;
    if (typeof obj.properties === 'object' && obj.properties !== null && !Array.isArray(obj.properties)) {
      Object.keys(obj.properties as Record<string, unknown>).forEach((key) => {
        if (/\s/.test(key)) names.add(key);
      });
    }
    Object.values(obj).forEach(visit);
  };
  visit(schema);
  return Array.from(names);
};
